import logo from "@/assets/logo/logo-icon.png";
import TextLogo from "@/assets/logo/text-logo.png";
import AcountSettngIcon from "@/assets/icons/AcountSettingIcon.svg";
import NotificationsIcon from "@/assets/icons/Notification.svg";
import SignOutIcon from "@/assets/icons/LogoutIcon.svg";
import ActiveIcon from "@/assets/icons/ActiveUserIcon.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useGetMeQuery } from "@/redux/feature/user/userApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { logOut } from "@/redux/feature/auth/authSlice";
import { TUser } from "@/types/types";
import { getInitials } from "@/utils/getFirstTwoLetter";
import { cn } from "@/lib/utils";
import MessagesIcon from "@/assets/icons/Messages.svg";

const items = [
  {
    label: "Account Settings",
    icon: <AcountSettngIcon />,
    path: "/profile",
  },

  {
    icon: <MessagesIcon />,
    label: "Messages",
    id: "messages",
    path: "messages",
  },
  {
    label: "Notification",
    icon: <NotificationsIcon />,
    path: "/notification",
  },
] as const;

interface SidebarProps {
  className?: string;
  /** Close the messaging drawer after navigation (mobile). */
  onClose?: () => void;
}

export function Sidebar({ className, onClose }: SidebarProps) {
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email ?? "", { skip: !user?.email });
  const userData: TUser | undefined = data?.data;
  const location = useLocation();
  const pathname = location.pathname;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const initials = userData?.fullName ? getInitials(userData.fullName) : "";

  const handleLogout = () => {
    dispatch(logOut());
    onClose?.();
    navigate("/auth/sign-in");
  };

  return (
    <aside
      className={cn(
        "flex flex-col h-full min-w-[290px] bg-white border-r border-[#EAEBED] pt-[50px] pb-7",
        className,
      )}
    >
      <div className="flex items-center gap-x-2 cursor-pointer px-6 mb-10">
        {/* <img src={logo} alt="Passionbits" /> */}
        {/* <img src={TextLogo} alt="" /> */}
      </div>

      <div className="mb-5 px-6">
        {userData?.profilePicture ? (
          <img
            className="w-14 h-14 rounded-full object-cover"
            src={userData.profilePicture}
            alt=""
          />
        ) : (
          <div className="size-10 flex justify-center items-center text-[#17457D] rounded-full text-sm font-semibold leading-5 relative bg-[#17457D0F]">
            {initials || "?"}
            <div className="absolute -bottom-[2px] -right-[3px]">
              <ActiveIcon />
            </div>
          </div>
        )}
        <p className="font-semibold pt-2 pb-1 text-body-regular">
          {userData?.fullName}
        </p>
        <p className="font-medium text-[#667085] text-caption2-regular truncate">
          {userData?.email}
        </p>
      </div>

      <ul className="space-y-[2px] px-3 flex-1">
        {items.map((item) => (
          <li key={item.path}>
            <Link to={item.path} onClick={() => onClose?.()} className="block">
              <div
                className={cn(
                  "px-3 py-[10px] flex flex-row gap-x-2 w-full items-center transition-all",
                  pathname === item.path || pathname.includes(item.path)
                    ? "bg-[#FEF4ED] border border-[#FFD6B9] rounded-[6px] text-[#ED5E00]"
                    : "text-[#62636C] bg-white border border-transparent",
                )}
              >
                <div className="w-5 shrink-0 flex items-center justify-center">
                  {item.icon}
                </div>
                <p className="whitespace-nowrap font-medium text-sm leading-5 tracking-[-0.0075em]">
                  {item.label}
                </p>
              </div>
            </Link>
          </li>
        ))}
        <li>
          <button
            type="button"
            onClick={handleLogout}
            className="px-3.5 py-[10px] flex w-full flex-row gap-x-2 items-center text-[#62636C] bg-white border-none"
          >
            <SignOutIcon />
            <span className="whitespace-nowrap font-medium text-sm leading-5 tracking-[-0.0075em]">
              Sign out
            </span>
          </button>
        </li>
      </ul>
    </aside>
  );
}
